import { render, staticRenderFns } from "./Matchingfunds.vue?vue&type=template&id=4b500e51&scoped=true&"
import script from "./Matchingfunds.vue?vue&type=script&lang=js&"
export * from "./Matchingfunds.vue?vue&type=script&lang=js&"
import style0 from "./Matchingfunds.vue?vue&type=style&index=0&id=4b500e51&scoped=true&lang=css&"
import style1 from "./Matchingfunds.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b500e51",
  null
  
)

export default component.exports